export default {
  login: 'Login',
  logout: 'Logout',
  signup: 'Sign up',
  signout: 'Sign out',
  withFeide: 'Login using Feide',
  email: 'E-mail',
  emailPlaceholder: 'example@email.com',
  password: 'Password',
  forgotYourPassword: 'Forgot your password?',
  enterYourEmail: 'Enter your email address',
  sendPasswordResetLink: 'Send password reset link'
}
